module.exports = __webpack_public_path__ + "static/img/A1.fc26c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/A1.png
// module id = DJ5g
// module chunks = 0